module.exports = __webpack_public_path__ + "static/media/PTPayrollCCExpanded.7b4f5935.png";